// extracted by mini-css-extract-plugin
module.exports = {"container":"PinnedReview_container__Bx7hS","inner_container":"PinnedReview_inner_container__CNq4H","mentee":"PinnedReview_mentee__O9ibw"};